<nav aria-label="Sidebar navigation" class="sidebar" data-testid="sidebar-nav">
  <!-- Close icon for mobile/tablet only -->
  <button *ngIf="isMobileOrTablet" mat-icon-button class="close-btn" (click)="closeSidenav.emit()" aria-label="Close sidenav" data-testid="close-sidenav-btn">
    <mat-icon>close</mat-icon>
  </button>
  <div class="sidebar__logo" data-testid="sidebar-logo">
     <div class="container_1-6">
    <img
          src="assets/images/CAIRE_Logo.svg"
          alt="Caire Logo"
          class="vector_1-9"
        />
    <!-- <div class="container_1-10">
      <div class="heading-1_1-11">
        <span class="text-caire_1-12">CAIRE</span>
      </div>
      <div class="text_1-13">
        <span class="text-connect-portal_1-14">Connect Portal</span>
      </div>
    </div> -->
  </div>
  </div>
 
<div class="sidebar__nav-scroll nav-scroll">
    <mat-accordion>
      <ng-container *ngFor="let item of navItems">
        <ng-container *ngIf="item.children && item.children.length; else singleLink">
          <mat-expansion-panel  #panel [expanded]="isChildRouteActive(item)" data-testid="sidebar-expansion-panel">
            <mat-expansion-panel-header [ngClass]="{'active': isChildRouteActive(item)}" data-testid="sidebar-expansion-header">
              <mat-panel-title>
                <span class="sidebar__panel_item" [ngClass]="{'active': isChildRouteActive(item)}">
                  <img *ngIf="item.headerIcon" [src]="item.headerIcon" class="header-svg" [ngClass]="{'icon-active': isChildRouteActive(item), 'icon-inactive': !isChildRouteActive(item)}" alt="" aria-hidden="true" />
                  <span class="label">{{ item.name | translate }}</span>
                </span>
              </mat-panel-title>
              <img *ngIf="panel.expanded" src="assets/images/up_arrow.svg" alt="closed">
              <img *ngIf="!panel.expanded" src="assets/images/rightarrow.svg" alt="open">
            </mat-expansion-panel-header>
            <ul class="submenu" data-testid="sidebar-submenu">
              <li *ngFor="let child of item.children">
                <a [routerLink]="child.route"
                   class="sidebar__item child-item"
                   routerLinkActive="active"
                   [routerLinkActiveOptions]="{ exact: true }"
                   >
                  <img
                    *ngIf="child.headerIcon; else dotPlaceholder"
                    [src]="child.headerIcon"
                    class="child-svg"
                    [ngClass]="{
                      'icon-active': isChildRouteActive({ route: child.route }),
                      'icon-inactive': !isChildRouteActive({ route: child.route })
                    }"
                    alt=""
                    aria-hidden="true"
                  />
                  <ng-template #dotPlaceholder>
                    <span
                      class="dot-icon"
                      [ngClass]="{ 'dot-placeholder': !isChildRouteActive({ route: child.route }) }"
                    ></span>
                  </ng-template>
                  <span class="child-label">{{ child.name | translate }}</span>
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
        </ng-container>
        <ng-template #singleLink >
          <a [routerLink]="item.route" class="sidebar__item main-item" [ngClass]="{'active': isChildRouteActive(item)}" >
             <img *ngIf="item.headerIcon" [src]="item.headerIcon" class="header-svg" [ngClass]="{'icon-active': isChildRouteActive(item), 'icon-inactive': !isChildRouteActive(item)}" alt="" aria-hidden="true" />
            <span class="label">{{ item.name | translate }}</span>
          </a>
        </ng-template>
      </ng-container>
    </mat-accordion>
  </div>
</nav>